import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeMount, ref } from 'vue'

import { DocView } from '@/models/doc'
import { HeaderView } from '@/models/header'

import HeaderAppDesktop from '@/app/components/header/AppDesktop.vue'
import HeaderInternal from '@/app/components/header/Internal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    doc: {}
  },
  setup(__props: any) {

const props = __props

const view = ref(new HeaderView(props.doc))

onBeforeMount(async () => {
  await view.value.init()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderAppDesktop, {
      class: _normalizeClass(view.value.headerClass)
    }, null, 8, ["class"]),
    _createVNode(HeaderInternal, {
      title: __props.doc.title,
      backLinkDoc: __props.doc,
      class: _normalizeClass(["header--scroll header--book", view.value.headerClass])
    }, null, 8, ["title", "backLinkDoc", "class"])
  ], 64))
}
}

})